export default __webpack_public_path__ + "static/media/benefit_12.71ce965b.svg";